import { createRouteContext } from '@/providers';
import { ReportsRoute } from '@/types/routes';

const {
    RouteProvider: ReportsRouteProvider,
    useRouteContext: useReportsRoute,
} = createRouteContext<ReportsRoute>();

export { ReportsRouteProvider, useReportsRoute };
